import React from 'react';
import TransformationTab from '../components/transformation/TransformationTab';

interface TransformationProps {
}

const Transformation: React.FC<TransformationProps> = () => {
  return <TransformationTab />;
};

export default Transformation;
